var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418",
    transform: "translate(0 0.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2266",
    "data-name": "Rectangle 2266",
    transform: "translate(0 -0.013)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 62.5,
    height: 62.5,
    rx: 4.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "location-pin-svgrepo-com",
    transform: "translate(16 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M23.173,0A15.173,15.173,0,0,0,8,15.173c0,3.59,1.582,6.746,3.332,9.483L22.142,39.929a1.264,1.264,0,0,0,2.064,0L35.014,24.657a16.993,16.993,0,0,0,3.332-9.483A15.173,15.173,0,0,0,23.173,0ZM33.344,24.657h-.006L23.173,38.566,13.009,24.657H13c-1.545-2.232-3.738-5.817-3.738-9.483a13.909,13.909,0,1,1,27.818,0C37.082,18.84,34.731,22.622,33.344,24.657Z",
    transform: "translate(-8)",
    fill: "#0ab8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M28.322,14a6.322,6.322,0,1,0,6.322,6.322A6.323,6.323,0,0,0,28.322,14Zm0,11.38a5.058,5.058,0,1,1,5.058-5.058A5.058,5.058,0,0,1,28.322,25.38Z",
    transform: "translate(-13.149 -5.149)",
    fill: "#0ab8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M26.851,10A8.851,8.851,0,1,0,35.7,18.851,8.851,8.851,0,0,0,26.851,10Zm0,16.438a7.587,7.587,0,1,1,7.587-7.587A7.587,7.587,0,0,1,26.851,26.438Z",
    transform: "translate(-11.678 -3.678)",
    fill: "#0ab8e5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.400ca9b21b5108f179651f516a8462b1.svg";
export { ForwardRef as ReactComponent };